import { render, staticRenderFns } from "./BasicPie.vue?vue&type=template&id=55b610f2&scoped=true"
import script from "./BasicPie.vue?vue&type=script&lang=js"
export * from "./BasicPie.vue?vue&type=script&lang=js"
import style0 from "./BasicPie.vue?vue&type=style&index=0&id=55b610f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b610f2",
  null
  
)

export default component.exports